import React from 'react';
import CustomImage from '../../../components/custom-image';
import PageLayout from '../../../layouts/pagelayout';
import SectionTitle from '../../../components/section-title';
import Collapse from '../../../components/collapse';
import BreadCrumb from '../../../components/breadcrumb';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const HindhustanZinc = () => {
  return (
    <PageLayout pageTitle="Vedanta - Hindustan Zinc" pageLink="/overview/case-studies/hindustan-zinc">
      <div className="case-study-section hindustan-section">
        <div className="casestudy-container left-img-content hindustan-container">
          <div className="section-inner hindustan-section-inner">
            <BreadCrumb />
            <ScrollPositionAnimation targetElement1="anim-one" targetElement2="anim-two">
              <div className="two-column">
                <div className="media">
                  <div className="left-to-right anim-one">
                    <div className="desktop-img">
                      <CustomImage
                        className="custom-image"
                        imageName="hindhustan-zinc.jpg"
                        alt="Indian self sufficiency"
                        maxWidth="748"
                      />
                    </div>
                    <div className="mobile-img">
                      <CustomImage
                        className="custom-image"
                        imageName="hindhustan-zinc-mobile.jpg"
                        alt="Indian self sufficiency"
                        maxWidth="748"
                      />
                    </div>
                  </div>
                </div>
                <div className="content">
                  <div className="bottom-to-top anim-two">
                    <SectionTitle
                      label="Case Study"
                      lighttext="HINDUSTAN ZINC:"
                      iconimage="hindhustan-zinc-icon.png"
                      boldtext="DRIVING DIGITAL DISRUPTION IN THE MINING SECTOR"
                    ></SectionTitle>
                    <p className="blue-text">
                      HZL remains at the forefront of transformation in the mining sector, implementing best-in-class
                      technological solutions to strengthen its competitive edge. Its journey towards digitalisation and
                      technological excellence has led to the emergence of several consequent opportunities in 2020 and
                      beyond.
                    </p>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
        <div className="casestudy-container right-img-content hindustan-container">
          <div className="section-inner">
            <ScrollPositionAnimation targetElement1="anim-three" targetElement2="anim-four">
              <div className="two-column">
                <div className="content text-57 content-width-57 ">
                  <div className="bottom-to-top anim-four">
                    <h3 className="section-title-width">DATA IS THE NEW GOLD, AND IN MINING IT IS A PRIORITY</h3>
                    <div className="media mobile-img">
                      <CustomImage
                        className="custom-image"
                        imageName="employee-at-operational-site-mobile.jpg"
                        alt="Employee at operational site"
                        maxWidth="608"
                      />
                    </div>
                    <p>
                      This year, HZL launched a collaboration centre, which can be easily termed as one of the world’s
                      best Internet of things (IoT) setups in the mining industry. This Centre has infused data-driven
                      decision-making across our operations. For us, this step goes a long way in nurturing an ecosystem
                      where our operations team, Original Equipment Manufacturers (OEMs), Subject Matter Experts (SMEs),
                      data scientists and senior management collaborate seamlessly towards meaningful outcomes. Relevant
                      data from our mines, mills, smelters and power plants are integrated into a single platform,
                      providing a holistic view and strengthening the foundation for a digital enterprise, while
                      offering several other possibilities.
                    </p>
                    <Collapse labelOne="Read More" labelTwo="Read Less">
                      <p>
                        The Centre is working on advanced analytical modelling to allow accurate predictions to prevent
                        major equipment failures and production losses, thereby optimising our assets and operations.
                        This strategy will lead to an increase in metal recovery by ~2%, while cost optimisation in our
                        underground operations and in the smelting process is already visible.
                      </p>
                    </Collapse>
                  </div>
                </div>
                <div className="media">
                  <div className="right-to-left anim-three">
                    <div className="desktop-img">
                      <CustomImage
                        className="custom-image"
                        imageName="employee-at-operational-site.jpg"
                        alt="Employee at operational site"
                        maxWidth="608"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>

        <div className="casestudy-container left-img-content hindustan-container">
          <div className="section-inner">
            <ScrollPositionAnimation targetElement1="anim-five" targetElement2="anim-six">
              <div className="two-column">
                <div className="media">
                  <div className="left-to-right anim-five">
                    <div className="desktop-img">
                      <CustomImage
                        className="custom-image"
                        imageName="underground-operation-sideshwar.jpg"
                        alt="Underground operation at sideshwar"
                        maxWidth="608"
                      />
                    </div>
                  </div>
                </div>
                <div className="content text-68">
                  <div className="bottom-to-top anim-six">
                    <h3 className="section-title-width">DRISHTI - AN EYE FOR DETAIL, EVEN A MILE UNDERGROUND</h3>
                    <div className="media mobile-img">
                      <CustomImage
                        className="custom-image"
                        imageName="underground-operation-sideshwar-mobile.jpg"
                        alt="Underground operation at sideshwar"
                        maxWidth="608"
                      />
                    </div>
                    <p>
                      HZL launched a project called ‘Drishti’ to make the underground mining process more predictable,
                      reliable and sustainable with maximum safety using state-of the art technology. Under ‘Drishti’,
                      we target to improve the overall underground equipment effectiveness by over 10% this year. To
                      achieve this, we established a high bandwidth Wi-Fi network to facilitate two-way communication
                      with underground equipment and personnel. This enables us to track man, machine and material
                      movement, examine progress of tasks on real-time basis and manage data centrally. In essence, it
                      helps us provide the right information at the right time, in the right format to the right person.{' '}
                    </p>
                    <Collapse labelOne="Read More" labelTwo="Read Less">
                      <p>
                        Under ‘Drishti’, we are now vested with a unique ability to monitor and predict the health of
                        equipment, which operate as deep as a kilometre below ground. This helps us shift from the
                        current practice of preventive to condition-based predictive maintenance. Additionally, this
                        will also empower us with a unique functionality of traffic management on ramp, which has the
                        potential to significantly reduce the idling time and ensure better safety.
                      </p>
                    </Collapse>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
        <div className="casestudy-container right-img-content  bottom-section hindustan-container">
          <div className="section-inner">
            <ScrollPositionAnimation targetElement1="anim-seven" targetElement2="anim-eight">
              <div className="two-column">
                <div className="content text-57 content-width-57">
                  <div className="bottom-to-top anim-eight">
                    <h3>EVOLVING METAL SALES CHANNEL AT HZL</h3>
                    <div className="media mobile-img">
                      <CustomImage
                        className="custom-image"
                        imageName="evolving-metal-sale-mobile.jpg"
                        alt="Elvolving metal sale"
                        maxWidth="608"
                      />
                    </div>
                    <p>
                      During FY2020, HZL’s marketing team completed the Phase I development milestone for e-Volve, a
                      first-in-the-Zinc industry, B2B online commerce platform. e-Volve is set to go-live in Q1FY21 and
                      will transform the way metals are purchased in India – and enable ‘Buy in three clicks’.{' '}
                    </p>
                    <p>
                      e-Volve aims to be the digital marketplace of choice for zinc, lead and silver consumers within
                      the country. It enables them to place orders in just three-clicks on real-time, INR prices with
                      minimum order quantity of as low as one tonne and offers delivery from our extensive network of
                      warehouses. This digital marketplace is expected to enable HZL reach out to over 2,000 customers
                      of zinc, lead and silver and will reduce transaction and inventory costs for the industry.
                    </p>
                  </div>
                </div>
                <div className="media">
                  <div className="right-to-left anim-seven">
                    <div className="desktop-img">
                      <CustomImage
                        className="custom-image"
                        imageName="evolving-metal-sale.jpg"
                        alt="Elvolving metal sale"
                        maxWidth="608"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default HindhustanZinc;
